export default __webpack_public_path__ + "images/357b7bf8741f6fe0c19e2a0162e96088-travel_small.webp";